import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/holidays',
    name: 'holiday',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/holiday/index.vue')
  }
]
